import React from "react";
import { cn } from "@/utils/helpers";
import { ControlsViewType } from "@/utils/types";
import { SvgIconProps } from "./SvgIcon";
import SvgIconViewSmoke from "./SvgIconViewSmoke";
import SvgIconViewHeat from "./SvgIconViewHeat";
import SvgIconViewCold from "./SvgIconViewCold";
import styles from "../Svg.module.css";

export interface SvgIconViewProps extends SvgIconProps {
	type: ControlsViewType;
	active?: boolean;
}

export default function SvgIconView({
	type,
	active,
	className,
	...props
} : SvgIconViewProps) {
	let SvgIconViewComponent;
	switch(type) {
		case "smoke":
			SvgIconViewComponent = SvgIconViewSmoke;
			break;
		case "heat":
			SvgIconViewComponent = SvgIconViewHeat;
			break;
		case "cold":
			SvgIconViewComponent = SvgIconViewCold;
			break;
	}
	return (
		SvgIconViewComponent ?
			<SvgIconViewComponent
				active={active}
				className={cn(
					styles.SvgIconView,
					className
				)}
				{...props}
			/>
		: null
	)
}
